module.exports = __webpack_public_path__ + "static/media/ingles.eea8ffcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/election/components/ChangeLenguage/flags/ingles.png
// module id = 6657
// module chunks = 0